export default __webpack_public_path__ + "static/media/passivesurfacewave.7b8ed75f.png";